import Home from "./auth/Home";
import { Routes, Route } from 'react-router-dom'
import RegisterUser from "./pages/users/RegisterUser";
import Login from "./auth/Login";
import Dashboard from "./pages/dashboard/Dashboard";
import DashboardComingSoon from "./pages/dashboard/DashboardComingSoon";
import { useEffect } from "react";
import UserDashboard from "./pages/dashboard/UserDashboard";
import AddUserMain from "./pages/users/AddUserMain";
import ClientMain from "./pages/clients/ClientMain";
import ClientCompanyMain from "./pages/client-company/ClientCompanyMain";
import ClientCompanyTypeMain from "./pages/client-company-type/ClientCompanyTypeMain";
import Components from "./shared/components/components";
import TaskMain from "./pages/Task/TaskMain";
import ManageTaskMain from "./pages/ManageTask/ManageTaskMain";
import RoleSecurityMain from "./pages/role-security/RoleSecurityMain";
import ReportsMain from "./pages/reports/ReportsMain";
import UserProfile from "./pages/users/UserProfile";
import ResetPassword from "./auth/ResetPassword";
import LeadMain from "./pages/lead/LeadMain";
import ClientCommunication from "./pages/client-communication/ClientCommunication";
import ClientEnvironmentMain from "./pages/client-environments/ClientEnvironmentMain";
import TitleMain from "./pages/titles/TitleMain";
import EnquiryMain from "./pages/enquiry/EnquiryMain";
import SalesRegisterMain from "./pages/sales-register/SalesRegisterMain";
import RTOMain from "./pages/rto/RTOMain";
import FinanceRegisterMain from "./pages/finance-register/FinanceRegisterMain";
import CustomerMain from "./pages/customer/CustomerMain";
import ColorMain from "./pages/color/ColorMain";
import MasterDataMain from "./pages/master-data/MasterDataMain";
import VehicleMain from "./pages/vehicle/VehicleMain";
import DealerMain from "./pages/dealer/DealerMain"; 
import PurchaseRegisterMain from "./pages/purchase-register/PurchaseRegisterMain";
import FinancePartnerMain from "./pages/finance-partner/FinancePartnerMain";
import HandoverItemsMain from "./pages/handover-items/HandoverItemsMain";
import HandoverRegisterMain from "./pages/handover-register/HandoverRegisterMain";
import LoanApplicatgionFromMain from "./pages/loan-application-form/LoanApplicatgionFromMain";
import CalendarMain from "./pages/Calendar/CalendarMain";
import TodoListMain from "./pages/todo-list/TodoListMain";



function App() {
  useEffect(() => {
        
  }, [])
  const applicationId = Number(process.env.REACT_APP_APPLICATION_ID || 0)
  return (
    <>
      <Routes>
        <Route path="/" element={<Login />}></Route>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/home" element={<Home />}>
          <Route path="dashboard" element={applicationId === 1 ? <Dashboard /> : <DashboardComingSoon />}></Route>
          <Route path="create-task"  element={<TaskMain Module={"Create Task"}/>}></Route>
          <Route path="manage-task"  element={<ManageTaskMain Module={"Manage Task"} DefaultTaskId={0}/>}></Route>
          <Route path="addUser"  element={<AddUserMain Module={"User"}/>}></Route>
          <Route path="user-dashboard"  element={<UserDashboard />}></Route>
          <Route path="addClient"  element={<ClientMain Module={"Clients"}/>}></Route>
          <Route path="client-company"  element={<ClientCompanyMain Module={"Client Company"}/>}></Route>
          <Route path="client-company-type"  element={<ClientCompanyTypeMain Module={"Client Company Type"} />}></Route>
          <Route path="components"  element={<Components Module={"Components"} />}></Route>
          <Route path="role-security"  element={<RoleSecurityMain Module={"Role Security"} />}></Route>
          <Route path="report"  element={<ReportsMain Module={"Reports"} />}></Route>
          <Route path="user-profile"  element={<UserProfile Module={"Profile"} />}></Route>
          <Route path="reset-password"  element={<ResetPassword Module={"Reset Password"} />}></Route>
          <Route path="lead"  element={<LeadMain Module={"Lead"} />}></Route>
          <Route path="client-communication"  element={<ClientCommunication Module={"Client Communication"} />}></Route>
          <Route path="client-environments"  element={<ClientEnvironmentMain Module={"Client Environments"} />}></Route>
          <Route path="titles"  element={<TitleMain Module={"Titles"} />}></Route>
          <Route path="enquiry"  element={<EnquiryMain Module={"Enquiry Register"} />}></Route>
          <Route path="sales-register"  element={<SalesRegisterMain Module={"Sales Register"} />}></Route>
          <Route path="purchase-register"  element={<PurchaseRegisterMain Module={"Purchase Register"} />}></Route>          
          <Route path="finance-register"  element={<FinanceRegisterMain Module={"Finance Register"} />}></Route>
          <Route path="rto"  element={<RTOMain Module={"RTO Register"} />}></Route>
          <Route path="customer"  element={<CustomerMain Module={"Customer"} />}></Route>
          <Route path="color"  element={<ColorMain Module={"Color"} />}></Route>
          <Route path="master-data"  element={<MasterDataMain Module={"Manage List"} />}></Route>
          <Route path="vehicle-entry"  element={<VehicleMain Module={"Vehicle"} />}></Route>
          <Route path="dealer"  element={<DealerMain Module={"Dealer"} />}></Route>
          <Route path="finance-partner"  element={<FinancePartnerMain Module={"Finance Partners"} />}></Route>
          <Route path="handover-items"  element={<HandoverItemsMain Module={"Handover Items"} />}></Route>
          <Route path="handover-register"  element={<HandoverRegisterMain Module={"Handover Register"} />}></Route>
          <Route path="loan-application-form" element={<LoanApplicatgionFromMain Module={"Loan Application Form"} />}></Route>
          <Route path="calendar" element={<CalendarMain Module={"Calendar"} />}></Route>
          <Route path="todo-list" element={<TodoListMain Module={"Todo List"} />}></Route>
        </Route>
        <Route path="/registeruser" element={<RegisterUser />}></Route>
      </Routes>
    </>
  );
}

export default App;
